export default __webpack_public_path__ + "static/media/mvoult-logo.2652a040.png";